import type {
  VisitWithRelations,
  Visit,
  CreateVisitWithAttendees,
  UpdateVisit,
} from '@markku/types'
import { createCrudHooks } from './base'

export const visitHooks = createCrudHooks<
  VisitWithRelations,
  Visit,
  CreateVisitWithAttendees,
  UpdateVisit
>('visit')
